import { render } from "./AddAutoresponder.vue?vue&type=template&id=04b463c2&ts=true"
import script from "./AddAutoresponder.vue?vue&type=script&lang=ts"
export * from "./AddAutoresponder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__